import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import { colors } from "../css components/Style";
import EmailVerify from "../../assets/email_verify.png";
import { alert } from "../../redux/slices/alertSlice";
import { PrimaryButton } from "../css components/Button";

export default function Form({ code }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const axios = useAxios({ disableAuthToken: true });

  return (
    <div className="wrapper-verify">
      <div className="outer-verify-div">
        <Grid container spacing={3} padding={"0 10px 0"} display={"block"}>
          <Grid item container xs={12} justifyContent={"center"}>
            <Grid size={12}>
              <Typography
                className="publicis-text"
                style={{ color: colors.publicisBlue }}
              >
                PUBLICIS
                <Typography
                  className="publicis-text"
                  style={{ color: colors.publicisSlateBlue }}
                >
                  &nbsp;ID
                </Typography>
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            xs={12}
            textAlign={"start"}
            margin={"25px 0 40px 0"}
          >
            <div className="image-text-div">
              <div
                className="image-business"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img src={EmailVerify} className="business-image" alt="!" />
              </div>

              <Typography className="business-heading" textAlign={"center"}>
                <Typography
                  style={{ color: colors.publicisBlue }}
                  className="congrat-text"
                >
                  {" "}
                  You are almost there! Welcome to the Ad Tech Platform!{" "}
                </Typography>

                <Typography className="congrat-text-2">
                  Please click the button below to verify your email account and
                  proceed to the next steps. We’re excited to have you with us!
                </Typography>
                <PrimaryButton
                  onClick={handleVerify}
                  variant="contained"
                  className="verify-btn"
                >
                  CLICK TO VERIFY
                </PrimaryButton>
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  function handleVerify() {
    axios({
      url: "/user/verifyEmail",
      method: "POST",
      data: {
        code: code,
        platform_id: 1,
      },
    }).then((res) => {
      if (res.status) {
        dispatch(
          alert({
            type: "success",
            message: res.message.displayMessage,
          })
        );
        navigate(pages.signIn.route);
      }
    });
  }
}
